
<template>
	<div class="container-fluid px-lg-2 px-xl-4">
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="row d-flex align-items-center">
			<div class="col-12 col-sm-7 pl-0">
				<nav aria-label="breadcrumb ">
					<ol class="breadcrumb pl-0">
						<li class="breadcrumb-item">Captura de pedidos</li>
						<li class="breadcrumb-item">Cambio de precios</li>
					</ol>
				</nav>
			</div>
		</div>

		<!-- Imagen Banner -->
		<div class="row" ref="ancla">
			<img alt="image slot" src="@/assets/img-priv/Banner Cambio de precio.png" width="100%" />
		</div>
		
		<pm-tabla-cambio-precio
			:current_page="current_page"
			:items="itemsEnvia"
			:numPages="numPages()"
			:paginas="paginas"
			@anterior="prevPage"
			@clickItem="redirect"
			@siguiente="nextPage"
			@navegar="navegar"
			class="mt-3 row"
		></pm-tabla-cambio-precio>
	</div>
</template>



<script>
	import PmTablaCambioPrecio from "@/components/clientes/TablaCambioPrecio"
	import servicio from "@/services/servicio-cambio-precio"

	export default {
		data() {
			return {
				items: [],
				itemsEnvia: [],
				current_page: 1,
				records_per_page: 20,
				inicio: 0,
				fin: 0,
				paginas: []
			}
		},
		components: {
			//PmImagenCambioPrecio,
			PmTablaCambioPrecio
			//PmTablaCambioPrecioMdLg
		},
		mounted() {
			this.$loading(true)
			servicio
				.getArticulosCambioPrecio()
				.then(r => {
					this.items = r.data
					this.changePage()
					this.$loading(false)
				})
				.catch(err => {
					console.error(err)
				})
			this.carritoConsultarCantidad()
			this.obtenerNotificaciones()
		},
		methods: {
			redirect(item) {
				this.$router.push({ path: `/clientes/detalle-producto/${item.codArticulo}` })
			},
			navegar(pagina){
				
				this.changePage()
				this.current_page = pagina
				this.$nextTick(()=>{
					this.scrollMeTo('ancla')
				})
			},
			prevPage() {
				if (this.current_page > 1) {
					this.current_page--
					this.changePage()
					this.$nextTick(()=>{
						this.scrollMeTo('ancla')
					})
				}
			},
			nextPage() {
				if (this.current_page < this.numPages()) {
					this.current_page++
					this.changePage()
					this.$nextTick(()=>{
						this.scrollMeTo('ancla')
					})
				}
			},
			changePage() {
				this.$nextTick(() => {
					this.inicio = this.current_page * this.records_per_page - this.records_per_page
					this.fin = this.current_page * this.records_per_page
					this.itemsEnvia = this.items.slice(this.inicio, this.fin)
					this.scrollMeTo('ancla')
				})

				this.paginadorBotones()
			},
			paginadorBotones(){
				
				if (this.current_page == null || this.numPages() == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicioPaginado = this.current_page - aux > 0 ? this.current_page - aux : 1

				let finPaginado = this.current_page + aux > this.numPages() ? this.numPages() : this.current_page + aux

				for (let i = inicioPaginado; i <= finPaginado; i++) {
					res.push(i)
				}

				this.paginas = res
				//console.log('res', this.paginas)
				
			},
			numPages() {
				return Math.ceil(this.items.length / this.records_per_page)
			}
		}
	}
</script>



<style scoped>
	.Titulo {
		font-family: "Open Sans";
		color: var(--bg-menu-blue);
		font-weight: bold;
	}
	/* sm */
	@media screen and (max-width: 767px) {
		.fuenteTitulo {
			text-align: left;
			font-size: 16px;
			font-family: "Open Sans";
			font-weight: bold;
			letter-spacing: 0;
			color: #0a2157;
		}
	}

	/* md */
	@media screen and (min-width: 768px) and (max-width: 991px) {
	}

	/* lg */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
	}

	/* xl */
	@media screen and (min-width: 1200px) {
	}
</style>
